/* eslint-disable jsx-a11y/no-autofocus */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Button, Input, Separator, Spinner } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import ProductConfigurationFieldValue from './ConfigurationFieldValue';

export default function ConfigurationField(props: {
	connectorType?: graphql.ConnectorType;
	field: graphql.ConnectorConfigField;
	onSave: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => Promise<void>;
}) {
	const { t } = useTranslation();

	const [editing, setEditing] = useState(false);
	const [loading, setLoading] = useState(false);

	const [change, setChange] = useState<
		Partial<graphql.UpdateConnectorConfigFieldInput> | undefined
	>();

	const usesAutoSave = props.field.type === graphql.ConnectorConfigFieldType.Oauth2;

	return (
		<>
			<Flex alignItems="flex-start">
				{'isSecret' in props.field &&
				props.field.isSecret &&
				props.field.isConfigured &&
				!editing ? (
					<Flex alignItems="center">
						<Input value="******" onChange={() => {}} disabled />
						<Button
							type="secondary"
							ml={2}
							title={t('connectors.settings.configuration.changeValue')}
							onClick={() => setEditing(true)}
						/>
					</Flex>
				) : (
					<ProductConfigurationFieldValue
						connectorType={props.connectorType}
						field={props.field}
						change={change}
						onChange={async (newValue) => {
							setChange(newValue);
							if (usesAutoSave) {
								setLoading(true);
								await props.onSave(newValue);
								setLoading(false);
							}
						}}
						autoFocus={editing}
					/>
				)}
				{loading && <Spinner ml={2} />}
			</Flex>

			{!usesAutoSave && change && (
				<Box mt={3} mx={-3}>
					<Separator />

					<Flex mt={3} mx={3}>
						<Button
							type="primary"
							title={t('common.save')}
							onClick={async () => {
								await props.onSave(change);
								setEditing(false);
								setChange(undefined);
							}}
						/>
					</Flex>
				</Box>
			)}
		</>
	);
}
